import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GfTranslateService } from '../../../core/services/core.translate.service';

import * as _ from 'lodash';

@Component({
    selector: 'gf-module-choice-buttons',
    template: require('./module-choice-buttons.html')
})
export class ModuleChoiceButtonsComponent implements OnChanges {

    @Input() choices = [];
    @Input() modules = [];
    @Input('pfx') prefix = '';
    
    @Output() callback = new EventEmitter();

    protected items = [];
    protected mainText = '';
    protected anyEnabled = false;

    constructor(private gfTranslateService: GfTranslateService) { }
    
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.choices || changes.modules) {
            this.items = _.map(
                this.choices,
                (c) => {
                    return {
                        choice: c,
                        label: this.moduleText(c),
                        enabled: this.moduleEnabled(c)
                    };
                }
            );
            this.setStateValues();
        }
    }

    // Functions for the individual module buttons
    moduleEnabled(myModule) {
        return (this.modules.indexOf(myModule) > -1);
    };

    moduleText(myModule) {
        return _.replace(myModule, this.prefix, '');
    };

    // Functions for the "global" on/off button
    setStateValues() {
        this.anyEnabled = (_.intersection(this.modules, this.choices).length > 0);
        this.mainText = this.anyEnabled ?
            this.gfTranslateService.translate('ON') :
            this.gfTranslateService.translate('OFF')
        ;
    };

    toggleAll() {
        if (this.anyEnabled) {
            this.callback.emit(false);
        } else {
            this.callback.emit(_.head(this.choices));
        }
    };
}